<template>
  <time :title="time" :datetime="time" class="bold">{{ prettyTime }}</time>
</template>

<script>
import { prettyDate } from '../filters.js'

export default {
  name: 'UpdatingTime',
  props: {
    time: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      prettyTime: '',
    }
  },
  mounted () {
    // reevaluate the time every X time

    const updateTime = () => {
      this.prettyTime = prettyDate(this.time)
    }

    updateTime()

    const second = 1000

    setInterval(() => {
      updateTime()
    }, 5 * second)
  },
}
</script>



// WEBPACK FOOTER //
// UpdatingTime.vue?46f6ecf3